import { Skeleton } from "@/components/ui/skeleton";
import type { FC } from "react";

const SkeletonRestaurantListInExplorer: FC = () => {
  return (
    <>
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
      <Skeleton className="w-[100%] h-[280px] rounded-[16px]" />
    </>
  );
};

export default SkeletonRestaurantListInExplorer;
